import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions, GradeOptions, StudentSexOptions } from "../../../../../../_helpers/Helpers";
import { useRegistrationCancellationReportUIContext } from "../RegistrationCancellationReportUIContext";

const prepareFilter = (queryParams, values) => {
  let { term, date, grade, identityCard, sex, other } = values;
  term = term === "" ? null : term;
  const newQueryParams = { ...queryParams };
  const filter = { term, date, grade, identityCard, sex, other };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function RegistrationCancellationReportFilter() {
  // Registration Cancellation Report UI Context
  const cancellationReportUIContext = useRegistrationCancellationReportUIContext();
  const cancellationReportUIProps = useMemo(() => {
    return {
      setQueryParams: cancellationReportUIContext.setQueryParams,
      queryParams: cancellationReportUIContext.queryParams,
    };
  }, [cancellationReportUIContext]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(cancellationReportUIProps.queryParams, values);
    if (!isEqual(newQueryParams, cancellationReportUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      cancellationReportUIProps.setQueryParams(newQueryParams);
    }
  };

  const gradeOptions = FilterOptions.concat(GradeOptions);
  const sexOptions = FilterOptions.concat(StudentSexOptions);

  return (
    <Formik
      initialValues={{
        term: "",
        identityCard: {
          name: "",
          surname: ""
        },
        other: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="term"
                min={1}
                placeholder="Dönem"
                onBlur={handleBlur}
                value={values.term}
                onChange={(e) => {
                  setFieldValue("term", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Dönem</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect
                options={gradeOptions}
                value={values.grade}
                placeholder="Sınıf"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("grade", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıf</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.identityCard.name}
                onChange={(e) => {
                  setFieldValue("identityCard.name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="surname"
                placeholder="Soyadı"
                onBlur={handleBlur}
                value={values.identityCard.surname}
                onChange={(e) => {
                  setFieldValue("identityCard.surname", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect
                options={sexOptions}
                value={values.sex}
                placeholder="Cinsiyeti"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("sex", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Cinsiyeti</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="other"
                placeholder="Diğer"
                onBlur={handleBlur}
                value={values.other}
                onChange={(e) => {
                  setFieldValue("other", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Diğer</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}